import { Link } from "react-router-dom";

const beats = [
  {
    icon: "ri-compass-3-line",
    title: "相遇",
    desc: "深夜电台里的第一声招呼，让阿浩、小雨与嘿咻猫咪的命运就此交织。",
  },
  {
    icon: "ri-hand-heart-line",
    title: "约定",
    desc: "一句随口许下的「十年之约」，成为贯穿全剧最温柔的暗线。",
  },
  {
    icon: "ri-arrow-left-right-line",
    title: "转折",
    desc: "新邻居阿玲的出现，让阿浩重新审视「陪伴」与「独处」的意义。",
  },
  {
    icon: "ri-sun-line",
    title: "告别与成全",
    desc: "结局那句「没说出口的再见」，把所有的伏笔收束成一场温柔的告别。",
  },
];

function PlotOverview() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-800">
              <i className="ri-film-line"></i>
              剧情速览
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              一条主线，四个关键节点
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              嘿咻嘿咻漫画用平淡的日常，铺出了一条动人的成长主线。从相遇、约定、转折到告别与成全，把故事脉络理顺，你就读懂了大半。
            </p>

            <div className="mt-8 space-y-4">
              {beats.map((b, i) => (
                <div key={b.title} className="flex gap-4 rounded-lg border border-background-200/70 bg-background-50 p-4">
                  <span className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className={`${b.icon} text-lg`}></i>
                  </span>
                  <div>
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-sm font-bold text-primary-700">
                        0{i + 1}
                      </span>
                      <h3 className="text-sm font-semibold text-foreground-950">{b.title}</h3>
                    </div>
                    <p className="mt-1 text-sm leading-relaxed text-foreground-600">{b.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/plot"
              className="mt-8 inline-flex items-center gap-2 rounded-md bg-secondary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-600 whitespace-nowrap"
            >
              展开完整剧情解析 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative">
            <img
              src="https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20a%20cozy%20desk%20scene%20with%20an%20open%20notebook%2C%20vintage%20microphone%20and%20a%20warm%20desk%20lamp%20casting%20amber%20glow%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%20and%20soft%20brush%20texture%2C%20contemplative%20storytelling%20mood%2C%20high%20detail&width=1000&height=760&seq=plot-overview&orientation=portrait"
              alt="剧情速览：深夜电台工作台的插画"
              className="w-full rounded-lg object-cover object-top"
            />
            <div className="absolute -bottom-5 -left-5 hidden rounded-lg bg-primary-500 px-5 py-4 text-background-50 shadow-soft md:block">
              <p className="text-xs text-background-100/90">全剧关键节点</p>
              <p className="font-heading text-2xl font-bold">4 大章节</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PlotOverview;